import React, { useEffect, useState, useCallback } from "react";
import LoadingInComponent from "../../Components/LoadingInComponent";
import Button from "../../Components/Button";
import { Add, Send2 } from "iconsax-react";
import MessageBlastTable from "./MessageBlastTable";
import { GET_EMAIL_TEMPLATE_LIST_API } from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { MESSAGE_BLAST_ADD } from "../../Router/path";
import Breadcrumb from "../../Components/Breadcrumb";
import Select from "react-select";
import Can from "../../Components/Can";

const MessageBlast = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("email");
  const [emailData, setEmailData] = useState();
  const [emailMeta, setEmailMeta] = useState();
  const [whatsAppData, setWhatsAppData] = useState();
  const [whatsAppMeta, setWhatsAppMeta] = useState();
  const [perPage, setPerPage] = useState(10);

  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const tabSelector = [
    {
      id: "email",
      label: "Email Template",
      function: () => {
        setCurrentTab("email");
        setEmailData(null);
        setEmailMeta({});
      },
      icon: <Send2 size="14" variant="Bold" />,
    },
    // {
    //   id: "whatsapp",
    //   label: "WhatsApp Template",
    //   function: () => {
    //     setCurrentTab("whatsapp");
    //     setWhatsAppData(null);
    //     setWhatsAppMeta({});
    //   },
    //   icon: <Whatsapp size="14" variant="Bold" />,
    // },
  ];

  const breadcrumbItems = [
    { label: "Message Blast" },
    { label: currentTab === "email" ? "Email Template" : "WhatsApp Template" },
    { label: "List" },
  ];

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchEmailTemplate();
    }
  };

  const clearFilter = () => {
    setSearchTerm("");
    setIsSearchCleared(true);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchEmailTemplate(1, e.target.value);
  };

  const handlePageClick = (e) => {
    fetchEmailTemplate(e.selected + 1);
  };

  const fetchEmailTemplate = useCallback(async (page = 1, perPageValue = perPage) => {
    setLoading(true);
    try {
      axios
        .get(GET_EMAIL_TEMPLATE_LIST_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: sessionStorage.getItem("event_id"),
            page: page,
            search: searchTerm,
            perPage: perPageValue,
            type: currentTab === "email" ? "email" : "whatsapp",
          },
        })
        .then((response) => {
          if (currentTab === "email") {
            setEmailData(response.data.data);
            setEmailMeta(response.data.meta.pagination);
          } else {
            setWhatsAppData(response.data.data);
            setWhatsAppMeta(response.data.meta.pagination);
          }
          setLoading(false);
        })
        .catch((error) => {
          toast("Failed to fetch email template", "error");
          setLoading(false);
        });
    } catch (error) {
      console.error(error);
      toast("Failed to fetch email template", "error");
    }
  }, [perPage, searchTerm, currentTab, toast]);

  useEffect(() => {
    if (location.state?.type) {
      setCurrentTab(location.state.type);
    }
  }, [location.state?.type]);

  useEffect(() => {
    setPerPage(10);
    setSearchTerm("");
    fetchEmailTemplate();
  }, [currentTab, fetchEmailTemplate]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchEmailTemplate();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchEmailTemplate]);

  return (
    <div className="flex flex-col w-full h-full overflow-x-hidden">
      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[24px]">
          {/* Breadcrumb */}
          <Breadcrumb items={breadcrumbItems} />

          {/* Title row */}
          <div className="flex flex-col md:flex-row w-full justify-between items-center">
            <h1 className="text-[29px]">
              {currentTab === "email" ? "Email Template" : "WhatsApp Template"}
            </h1>
            <Can permission="create_message_blast">
              <Button
                onClick={() =>
                  navigate(MESSAGE_BLAST_ADD, { state: { type: currentTab } })
                }
              >
                <Add size="16" variant="Outline" />
                Add template
              </Button>
            </Can>
          </div>

          {/* Event information section */}
          <div className="flex flex-col md:flex-row w-full h-full gap-[24px]">
            {/* Side bar */}
            <div className="hidden md:flex flex-col w-full md:w-[288px] h-fit gap-[8px]">
              {tabSelector.map((tab) => (
                <Button
                  key={tab.label}
                  variant={
                    currentTab === tab.label.toLowerCase().split(" ")[0]
                      ? "sidebar_active"
                      : "sidebar"
                  }
                  className="w-full"
                  onClick={tab.function}
                >
                  {tab.icon}
                  {tab.label}
                </Button>
              ))}
            </div>

            <div className="md:hidden w-full">
              <Select
                value={tabSelector.find((tab) => tab.id === currentTab)}
                name="tabSelection"
                options={tabSelector}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.label}
                onChange={(selected) => setCurrentTab(selected.id)}
              />
            </div>

            {/* Active tabs */}
            <div className="w-full">
              {/* Email */}
              {currentTab === "email" && emailData && emailMeta && (
                <MessageBlastTable
                  data={emailData}
                  meta={emailMeta}
                  currentTab={currentTab}
                  searchTerm={searchTerm}
                  handleSearch={handleSearch}
                  handleKeyDown={handleKeyDown}
                  handlePageClick={handlePageClick}
                  setLoading={setLoading}
                  perPage={perPage}
                  handlePerPageChange={handlePerPageChange}
                  clearFilter={clearFilter}
                />
              )}

              {/* whatsapp */}
              {currentTab === "whatsapp" && whatsAppData && whatsAppMeta && (
                <MessageBlastTable
                  data={whatsAppData}
                  meta={whatsAppMeta}
                  currentTab={currentTab}
                  searchTerm={searchTerm}
                  handleSearch={handleSearch}
                  handleKeyDown={handleKeyDown}
                  handlePageClick={handlePageClick}
                  setLoading={setLoading}
                  perPage={perPage}
                  handlePerPageChange={handlePerPageChange}
                  clearFilter={clearFilter}
                />
              )}
            </div>
          </div>
        </div>
      </LoadingInComponent>
    </div>
  );
};

export default MessageBlast;
